import dynamic from "next/dynamic";
import Head from "next/head";
import { useContext, useEffect } from "react";
import { newVehicles, vehicles } from "../../../../../src/constants/vehicleData";
import { imagesWEBP } from "../../../../../src/constants/webpImages";
import { Context } from "../../../../../src/context/context";
import { sendAnalytics } from "../../../../../src/utils/analyticsCommon";
import {
  TITLE,
  META_NAME,
  META_CONTENT,
  META_KEYWORDS_NAME,
  META_KEYWORDS_CONTENT,
  KEY_SPECIFICATION_HEADER,
  HIGHLIGHTS_HEADER,
  SUB_TEXT,
  BENEFITS_HEADER,
  VEHICLE_FEATURE_HEADER,
  BRAND_DEALER_HEADER,
  BRAND_DEALER_DESCRIPITION,
  FAQ_HEADER_TEXT,
  H1_HEADING,
} from "../../../../../src/constants/PassengerLandingPageContants/StormEv";

const ElectricPassengerVehicleLandingPage = dynamic(
  () =>
    import(
      "../../../../../src/modules/ElectricPassengerVehicleLandingPage/ElectricPassengerVehicleLandingPage"
    ),
  { suspense: true }
);
export default function VehicleModelDetails({
  brand,
  vehicleModel,
  vehicleDataLocal,
}) {
  const noentryData = [
    {
      id: 1,
      imageName: imagesWEBP?.MahindraTreoPlus?.MahindraTreoPlusVehicle1,
    },
    {
      id: 2,
      imageName: imagesWEBP?.MahindraTreoPlus?.MahindraTreoPlusVehicle2,
    },
    {
      id: 3,
      imageName: imagesWEBP?.MahindraTreoPlus?.MahindraTreoPlusVehicle3,
    },
    {
      id: 4,
      imageName: imagesWEBP?.MahindraTreoPlus?.MahindraTreoPlusVehicle4,
    },
  ];
  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: `electric_passenger_vehicle_${brand}_${vehicleModel}` },
      "en"
    );
  }, [brand, vehicleModel]);

  const state = useContext(Context);
  let location =
    state?.selectedState === "Others" ? "India" : state?.selectedState;
  //We need to add SEO Meta info later
  return ( 
    <>
      <Head>
        <title>Euler Storm EV Price in 2026 - Range, Specification & Reviews | Turno</title>
        <meta
          name="description"
          content="Looking for Euler Storm EV price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026."
        />
        <meta
          name="keywords"
          content="Euler Storm EV, Euler Storm EV price, electric commercial vehicle, Euler electric 4-wheeler, Storm EV specifications, electric vehicle range, Euler EV, electric vehicle price, Turno"
        />
        <meta name="author" content="Turno" />
        <meta
          name="url"
          content="https://www.turno.club/electric-commercial-vehicles/4w/Euler/Storm-Ev"
        />

        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Facebook */}
        <meta
          property="og:url"
          content="https://www.turno.club/electric-commercial-vehicles/4w/Euler/Storm-Ev"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Euler Storm EV Price in 2026 - Range, Specification & Reviews | Turno"
        />
        <meta
          property="og:description"
          content="Looking for Euler Storm EV price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026."
        />
        <meta property="og:image" content="/logoIcon.png" />
        <meta property="fb:app_id" content="5796260583761767" />
        <meta property="fb:pages" content="646488286564232" />

        {/* Twitter */}
        <meta
          name="twitter:description"
          content="Looking for Euler Storm EV price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026."
        />
        <meta
          name="twitter:title"
          content="Euler Storm EV Price in 2026 - Range, Specification & Reviews | Turno"
        />
        <meta name="twitter:site" content="@Turno" />
        <meta name="twitter:creator" content="@Turno" />
        <meta
          name="twitter:url"
          content="https://www.turno.club/electric-commercial-vehicles/4w/Euler/Storm-Ev"
        />
        <meta
          name="twitter:app:id:googleplay"
          content="com.customerapp.turno.turno_customer_application"
        />
        <meta name="twitter:app:country" content="IN" />
        <link rel="canonical" href="https://www.turno.club/electric-commercial-vehicles/4w/Euler/Storm-Ev" />
      </Head>
      <ElectricPassengerVehicleLandingPage
        title={TITLE}
        metaName={META_NAME}
        metaContent={META_CONTENT}
        brand={brand}
        vehicleModel={vehicleModel}
        location={location}
        vehicleDataLocal={vehicleDataLocal}
        vehicleName={"stormEv"}
        META_KEYWORDS_NAME={META_KEYWORDS_NAME}
        META_KEYWORDS_CONTENT={META_KEYWORDS_CONTENT}
        KEY_SPECIFICATION_HEADER={KEY_SPECIFICATION_HEADER}
        HIGHLIGHTS_HEADER={HIGHLIGHTS_HEADER}
        SUB_TEXT={SUB_TEXT}
        BENEFITS_HEADER={BENEFITS_HEADER}
        VEHICLE_FEATURE_HEADER={VEHICLE_FEATURE_HEADER}
        BRAND_DEALER_HEADER={BRAND_DEALER_HEADER}
        BRAND_DEALER_DESCRIPITION={BRAND_DEALER_DESCRIPITION}
        FAQ_HEADER_TEXT={FAQ_HEADER_TEXT}
        imagesWEBP={imagesWEBP}
        noentryData={[]}
        H1_HEADING={H1_HEADING}
      />
    </>
  );
}

export const getStaticProps = (context) => {
  let vehicleData = [...vehicles, ...newVehicles];

  const brand = "Euler";
  const vehicleModel = "Storm-Ev";

  let vehicleDataLocal = vehicleData?.filter(function (vehicle) {
    return vehicle?.vehicle_path_id === `${vehicleModel}`;
  });
  let latestVehiclesInfo = vehicleData?.filter((vehicle) => {
    return vehicle?.vehicle_path_id !== `${vehicleModel}`;
  });

  return {
    props: { brand, vehicleModel, vehicleDataLocal, latestVehiclesInfo },
  };
};
